export const MAIN_ADMIN_SET_COMPANIES = 'MAIN_ADMIN_SET_COMPANIES';
export const MAIN_ADMIN_SET_NEW_DATE_FOR_COMPANY =
  'MAIN_ADMIN_SET_NEW_DATE_FOR_COMPANY';
